export enum CreativeTagTracking {
  Init = 'Init',
  Request = 'Request',
  Load = 'Load',
  Installed = 'Installed',
  Display = 'Display',
  View = 'View',
  Timespent = 'timespent',
  Show = 'Show',
  Click = 'Click',
  Fail = 'Fail',
  Reach = 'Reach',
  Complete = 'Complete',
  ChapterViewed = 'chapter_viewed',
  NavigationSlide = 'navigation_slide',
  NavigationSiteScroller = 'navigation_site_scroller',
  Redirection = 'redirection',

  VideoStart = 'video_start',
  VideoFirstQuartile = 'video_first_quartile',
  VideoMidpoint = 'video_midpoint',
  VideoThirdQuartile = 'video_third_quartile',
  VideoComplete = 'video_complete'
}
